// extracted by mini-css-extract-plugin
export var attachment = "_rm-a";
export var emailContainer = "_rm-4";
export var emailContentPaddedContainer = "_rm-b";
export var emailHeader = "_rm-6";
export var emailIframe = "_rm-3";
export var emailInfoIcon = "_rm-9";
export var emailShortenedSummary = "_rm-e";
export var infoDropdown = "_rm-0";
export var infoRowBoundedContent = "_rm-d";
export var internal = "_rm-5";
export var merchant = "_rm-8";
export var messageInputContainer = "_rm-h";
export var normal = "_rm-7";
export var replyCard = "_rm-f";
export var subtleButton = "_rm-1";
export var subtleButtonIconContainer = "_rm-2";
export var toggleViewRepliesButton = "_rm-c";
export var wrappingText = "_rm-g";